module.exports = __webpack_public_path__ + "img/public/SiteIcons/NoreservationIocn.svg?5f0fcbde";